import * as React from "react";
function InformationPromoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.29 21a.805.805 0 01-.637-.314l-9.995-9.995a2.548 2.548 0 01-.653-1.555L3 4.148C3 3.514 3.515 3 4.148 3h4.965a2.538 2.538 0 011.562.639l10.011 10.016a.806.806 0 01-.356 1.43l-4.02 1.226-1.227 4.019a.81.81 0 01-.792.67zM4.149 3.765a.383.383 0 00-.383.383l.005 4.967c.021.378.179.756.443 1.05l10.001 10a.331.331 0 01.045.054.037.037 0 00.027.015c.025 0 .04-.014.043-.033a.34.34 0 01.015-.068l1.295-4.24a.38.38 0 01.254-.253l4.241-1.295a.31.31 0 01.066-.014.043.043 0 00.027-.016.04.04 0 00-.01-.056.335.335 0 01-.05-.042L10.147 4.193a1.732 1.732 0 00-1.05-.428h-4.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.207 9.12a1.914 1.914 0 01-1.913-1.912c0-1.055.858-1.913 1.913-1.913 1.055 0 1.913.858 1.913 1.913A1.915 1.915 0 017.207 9.12zm0-3.06a1.149 1.149 0 000 2.295c.633 0 1.147-.515 1.147-1.147 0-.633-.514-1.148-1.147-1.148z"
  }));
}
const ForwardRef = React.forwardRef(InformationPromoIcon);
export default ForwardRef;